import { render, staticRenderFns } from "./AnnouncementsEdit.vue?vue&type=template&id=204e0e6e&"
import script from "./AnnouncementsEdit.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports